import React from "react";
import { connect } from "react-redux";

import DataGrid, {
  Column,
  LoadPanel,
  Scrolling,
  FilterRow,
  Selection
} from "devextreme-react/data-grid";
import OutsideClickHandler from "react-outside-click-handler";
import CachedIcon from "@material-ui/icons/Cached";
import { withStyles } from "@material-ui/core/styles";
import { columns } from "./utils";
import SquareButton from "../../../../../ui/SquareButton";
import AddButton from "../../../../../ui/AddButton";
import SearchField from "../../../../../ui/SearchField";
import ActionsMenu from "../../../../../ui/ActionsMenu";
import Box from "../../../../../ui/Box";
import DeleteConfirmationModal from "../../../../../ui/DeleteConfirmationModal";
import AddResourceModal from "../AddResourceModal";

const styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "calc(100vh - 200px)"
    }
  },
  controls: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "16px",
    "& > div": {
      display: "flex",
      alignItems: "flex-end",
      "& > *:not(:nth-last-child(1))": {
        marginRight: "14px"
      }
    }
  }
};

class ResourceTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      selectedResources: [],
      deleteConfimationOpen: false,
      addSiteOpen: false,
      focusedResource: -1,
      focusedRowIndex: -1
    };

    this.selectResources = this.selectResources.bind(this);
    this.deleteResources = this.deleteResources.bind(this);
    this.exportSelectedResources = this.exportSelectedResources.bind(this);
    this.searchByText = this.searchByText.bind(this);
    this.triggerColumnChooser = this.triggerColumnChooser.bind(this);
    this.showDeleteModal = this.showDeleteModal.bind(this);
    this.showAddModal = this.showAddModal.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.dataGridRef = React.createRef();
  }

  selectResources({ selectedRowsData }) {
    this.setState({ selectedResources: selectedRowsData });
  }

  deleteResources() {
    const { deleteResources } = this.props;
    const IdList = this.state.selectedResources.map(({ id }) => id);

    deleteResources(IdList);
  }

  exportSelectedResources(selectionOnly) {
    this.dataGridRef.current.instance.exportToExcel(selectionOnly);
  }

  searchByText(e) {
    const text = e.target.value;
    this.dataGridRef.current.instance.searchByText(text);
  }

  triggerColumnChooser() {
    this.dataGridRef.current.instance.showColumnChooser();
  }

  showDeleteModal() {
    this.setState({
      deleteConfimationOpen: !this.state.deleteConfimationOpen
    });
  }

  showAddModal() {
    this.setState({ addSiteOpen: !this.state.addSiteOpen });
  }

  onRowClick(e) {
    //const focusedResource = e !== -1 ? e.data.id : e;
    //const focusedRowIndex = e !== -1 ? e.rowIndex : e;
    //this.setState({ focusedResource, focusedRowIndex });
  }

  render() {
    const {
      selectedResources,
      deleteConfimationOpen,
      addSiteOpen,
      focusedRowIndex,
      focusedResource
    } = this.state;

    const {
      resourcesData,
      classes,
      getResources,
      isDeletingResources,
      createResource,
      selectResource
    } = this.props;

    const actionmenu = [
      {
        label: "Удалить выбранные",
        onClick: this.showDeleteModal,
        disabled: isDeletingResources || selectedResources.length === 0
      },
      {
        label: "Экспортировать выбранные",
        onClick: () => this.exportSelectedResources(true)
      },
      {
        label: "Экспортировать все",
        onClick: () => this.exportSelectedResources(false)
      },
      {
        label: "Выбор видимых столбцов",
        onClick: this.triggerColumnChooser
      }
    ];

    return (
      <div className={classes.root}>
        <Box>
          <DeleteConfirmationModal
            modalText="Удалить выбранные ресурсы?"
            open={deleteConfimationOpen}
            onConfirm={this.deleteResources}
            handleClose={this.showDeleteModal}
          />
          <AddResourceModal
            open={addSiteOpen}
            handleClose={this.showAddModal}
            createResource={createResource}
            isCreatingResource={resourcesData.isCreatingResource}
            createdResource={resourcesData.createdResource}
          />
          <div className={classes.controls}>
            <div>
              <SquareButton>
                <CachedIcon fontSize="small"/>
              </SquareButton>
              <SearchField width={400} />
            </div>
            <div>
              <AddButton onClick={this.showAddModal}/>
              <ActionsMenu actions={actionmenu} />
            </div>
          </div>
          <div>
            <DataGrid
              elementAttr={{
                id: "gridContainer"
              }}
              ref={this.dataGridRef}
              wordWrapEnabled={true}
              dataSource={resourcesData.resources}
              onSelectionChanged={this.selectResources}
              focusedRowEnabled
              errorRowEnabled={false}
              onRowClick={(e) => {selectResource(e.data.id)}}
              focusedRowIndex={focusedRowIndex}
              showBorders
            >
              <Selection
                mode="multiple"
                showCheckBoxesMode="onClick"
                showBorders={true}
                width={120}
              />
              {columns.map(column => (
                <Column key={column.dataField} {...column} />
              ))}
              <FilterRow visible={true} />
              <Scrolling mode="virtual" />
              <LoadPanel enabled />
            </DataGrid>
          </div>
        </Box>

      </div>
    );
  }
}

export default withStyles(styles)(ResourceTable);
